import { render, staticRenderFns } from "./SBButtonSmallGray.html?vue&type=template&id=0043e9ce&scoped=true&"
import script from "./SBButtonSmallGray.ts?vue&type=script&lang=ts&"
export * from "./SBButtonSmallGray.ts?vue&type=script&lang=ts&"
import style0 from "./SBButtonSmallGray.css?vue&type=style&index=0&id=0043e9ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0043e9ce",
  null
  
)

export default component.exports